import React from 'react';
import { X } from 'lucide-react';
import { Card } from './Card';

const Modal = ({ isOpen, onClose, children, className = '', zIndex = 'z-50' }) => {
  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center ${zIndex} p-4`}
      onClick={onClose}
      role="presentation"
    >
      <Card
        className={`relative shadow-lg ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 z-10 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close"
        >
          <X className="h-5 w-5" />
        </button>
        {children}
      </Card>
    </div>
  );
};

export default Modal;
